export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS'
export const GET_NOTIFICATIONS_COUNT = 'GET_NOTIFICATIONS_COUNT'
export const READ_NOTIFICATIONS = 'READ_NOTIFICATIONS'
export const READ_ALL_NOTIFICATIONS = 'READ_ALL_NOTIFICATIONS'
